import styled from 'styled-components'

export const Link = styled.a`
  color: #000;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: #000;
    text-decoration: none;
  }
`
